function injectBehavior(controller, method, behavior) {
  const currentMethod = controller[method];
  controller[method] = () => {
    behavior();
    currentMethod?.bind(controller)?.();
  }
}

function useListener(controller, target, event, callback, options) {
  const $callback = callback.bind(controller);
  target.addEventListener(event, $callback, options);
  injectBehavior(controller, 'disconnect', () => {
    target.removeEventListener(event, $callback);
  });
}

function useWindowListener(controller, event, callback, options = {}) {
  useListener(controller, window, event, callback, options);
}

function useDocumentListener(controller, event, callback, options = {}) {
  useListener(controller, document, event, callback, options);
}

function useElementListener(controller, element, event, callback, options = {}) {
  useListener(controller, element, event, callback, options);
}

export { useDocumentListener, useElementListener, useWindowListener };